import { usePushdownContext } from '../../../../../../../../providers/Pushdown/PushdownProvider';
import { ISubmitResponseError } from '../../../../../../../../types/shared/PrequalificationDataEntry';
import { TPersonalInformation } from '../../../../../../providers/PersonalInformationProvider';
import { useHomeAddressError } from '../../../../../../providers/HomeAddressErrorProvider';
import { usePersonalInformationError } from '../../../../../../providers/PersonalInformationErrorProvider';
import { THomeAddress } from '../../../../../../providers/HomeAddressProvider';
import { IErrorState } from '../../../../../../providers/reducers/ErrorReducer';

export default function useSubmitResponseValidation() {
    const { personalInformationError, dispatch: piDispatch } =
        usePersonalInformationError();
    const { homeAddressError, dispatch: haDispatch } = useHomeAddressError();
    const { closePushdown } = usePushdownContext();

    const handleValidationFromApi = (errors: ISubmitResponseError[] | null) => {
        closePushdown();

        let hasHomeAddress = false;

        const personalInformationPayload: Record<string, IErrorState> = {};
        const homeAddressPayload: Record<string, IErrorState> = {};

        if (errors !== null) {
            errors.forEach(({ FieldName }) => {
                const isHomeAddress = FieldName.toLowerCase().includes('home');

                if (!hasHomeAddress) {
                    if (isHomeAddress) {
                        hasHomeAddress = true;
                    }
                }

                let resolvedKeys = [FieldName];
                if (FieldName === 'MailingAddressLines') {
                    resolvedKeys = ['MailingAddressLine1', 'MailingAddressLine2'];
                } else if (FieldName === 'HomeAddressLines') {
                    resolvedKeys = ['HomeAddressLine1', 'HomeAddressLine2'];
                } else if (FieldName === 'Under19YearDOB') {
                    resolvedKeys = ['dob'];
                }

                resolvedKeys.forEach(resolvedKey => {
                    if (isHomeAddress) {
                        const key = resolvedKey as keyof THomeAddress;
                        homeAddressPayload[key] = {
                            ...homeAddressError[key],
                            isInError: true,
                            isValidValue: false,
                        };
                    } else {
                        const key = resolvedKey as keyof TPersonalInformation;
                        personalInformationPayload[key] = {
                            ...personalInformationError[key],
                            isInError: true,
                            isValidValue: false,
                        };
                    }
                });
            });

            piDispatch({
                type: 'batchSetValid',
                payload: personalInformationPayload,
            });
        }

        if (hasHomeAddress) {
            haDispatch({ type: 'batchSetValid', payload: homeAddressPayload });
        }
    };

    return {
        handleValidationFromApi,
    };
}
